import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Box } from 'grommet'
import { TextLink } from 'secondstep-components'

export const UnitComponentWrapper = styled(Box)`
  flex-direction: column;
  padding: 0 0 ${themeGet('spacing.amber28_1_75rem')};
  width: 100%;
`

export const UnitTopContent = styled(Box)`
  width: 100%;
  box-sizing: border-box;
  padding: 0 1.5rem;
`

export const UnitOverviewBox = styled(Box)`
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  position: relative;
  z-index: 1;
  flex-direction: row;
  gap: ${themeGet('spacing.turquoise20_1_25rem')};

  ${themeGet('breakpoints.tablet')} {
    flex-direction: column;
    gap: ${themeGet('spacing.blue16_1rem')};
  }
`

export const UnitBodyBackground = styled(Box)`
  box-sizing: border-box;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0 1.5rem 1rem;
  background: linear-gradient(
    to bottom,
    #ffffff 0,
    #ffffff 26rem,
    #f3f4f6 26rem,
    #f3f4f6 100%
  );
`

export const UnitBodyContent = styled(Box)`
  width: 100%;
  box-sizing: border-box;
  padding: 0;
`

export const AcknowledgementsLink = styled(TextLink)`
  @media (max-width: 625px) {
    justify-content: center;
  }
`
